import React from "react";
export const CardContext = React.createContext("");
export const CardHeaderSearchSlotContext = React.createContext(null);